module.exports = __webpack_public_path__ + "img/bgIcon_2.3ad8bd22.png";